import React from "react";
import { Modal } from "react-bootstrap";
import Login from "../../Pages/LoginRegister/Login";
import useLoginState from "./useLoginState";
import backBtn from "./../../Assets/Icons/back.png";
import "./FoodItem.css";

export default function UnauthorizeLogin({ loginModalOpen, handleCloseLogin }) {
  const {
    passwordView,
    setPasswordView,
    handleUserFound,
    forgetPassword,
    setforgetPassword,
    isRegisterPage,
    isForgetPasswordSubmited,
    setisForgetPasswordSubmited,
    forgetPasswordToggle,
    hideModalInfo,
    closeForgetPassword,
    dispatch,
    openRegisterPageFalse,
  } = useLoginState();

  return (
    <Modal
      show={loginModalOpen}
      onHide={handleCloseLogin}
      backdrop="static"
      centered
      size="md"
      className="food-auth-modal"
      backdropClassName="food-auth-modal-backdrop"
    >
      <div className='modal-header d-flex justify-content-between loginModalCloseBtn'>
        {passwordView ? (
          <button
            type='button'
            className={"close-btn " + (isRegisterPage ? "d-none" : "")}
            onClick={() => {
              setPasswordView(false);
              setisForgetPasswordSubmited(false);
              dispatch(openRegisterPageFalse());
            }}
          >
            <img src={backBtn} alt='' style={{ width: "1.2rem" }} />
          </button>
        ) : forgetPassword ? (
          forgetPasswordToggle ? (
            ""
          ) : (
            <button
              type='button'
              className={"close-btn " + (isRegisterPage ? "d-none" : "")}
              onClick={() => {
                setforgetPassword(false);
                setPasswordView(true);
                setisForgetPasswordSubmited(false);
                dispatch(closeForgetPassword());
                dispatch(openRegisterPageFalse());
              }}
            >
              <img src={backBtn} alt='' style={{ width: "1.2rem" }} />
            </button>
          )
        ) : (
          <button
            type='button'
            className={"close-btn " + (isRegisterPage ? "d-none" : "")}
            onClick={handleCloseLogin || hideModalInfo}
          >
            <span aria-hidden='true'>&times;</span>
          </button>
        )}

        <button
          type='button'
          className={"close " + (isRegisterPage ? "" : "d-none")}
          onClick={() => dispatch(openRegisterPageFalse())}
        >
          <img src={backBtn} alt='' style={{ width: "1.2rem" }} />
        </button>

        <button
          type='button'
          className={
            "close " + (forgetPassword && forgetPasswordToggle ? "" : "d-none")
          }
          onClick={() => {
            dispatch(closeForgetPassword());
            setforgetPassword(false);
          }}
        >
          <img src={backBtn} alt='' style={{ width: "1.2rem" }} />
        </button>

        {forgetPassword && forgetPasswordToggle ? (
          <h5
            className={"modal-title " + (isRegisterPage ? "d-none" : "")}
            id='exampleModalLongTitle'
          >
            Forget Password
          </h5>
        ) : (
          <>
            {/* Login or Signup */}
            <h5
              className={"modal-title " + (isRegisterPage ? "d-none" : "")}
              id='exampleModalLongTitle'
            >
              Log in or sign up
            </h5>

            {/* Finish Signing Up + Close Button */}
            {isRegisterPage && (
              <div className='position-relative w-100 text-center'>
                <h5 className='modal-title m-0' id='exampleModalLongTitle'>
                  Finish signing up
                </h5>
                <button
                  type='button'
                  className='close-btn position-absolute'
                  style={{
                    right: "0",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                  onClick={handleCloseLogin || hideModalInfo}
                >
                  <span aria-hidden='true'>&times;</span>
                </button>
              </div>
            )}
          </>
        )}

        <span></span>
      </div>

      <Modal.Body>
        {loginModalOpen ? (
          <Login
            loaded='false'
            userFound={handleUserFound}
            userFoundFlag={passwordView}
            forgetEmail={(props) => {
              setforgetPassword(props);
              setPasswordView(false);
            }}
            isRegisterPage={isRegisterPage}
            isForgetPasswordSubmited={isForgetPasswordSubmited}
            returnUrl={window.location.href}
          />
        ) : (
          "loading"
        )}
      </Modal.Body>
    </Modal>
  );
}
